import { LogLevel } from '@datocms/cma-client-browser';
import { VideoStatus } from '@src/types.ts/video';
import { createDatoClient } from '@src/utility/dato';
import { Button, Canvas } from 'datocms-react-ui';

import { Studio } from '../types.ts/general';

import type { RenderFieldExtensionCtx } from 'datocms-plugin-sdk';

type PropTypes = {
  ctx: RenderFieldExtensionCtx;
};

export default function FinalVideo({ ctx }: PropTypes) {
  const dClient = createDatoClient({
    apiToken: ctx.currentUserAccessToken || null,
    environment: ctx.environment,
    logLevel: LogLevel.NONE,
  });

  const handleOpenModal = async () => {
    try {
      if (ctx.item?.id) {
        // this line will throw error if can't save
        if (ctx.item.attributes.final_video_status !== VideoStatus.Rendering) {
          await dClient.items.update(ctx.item?.id, {
            final_video_status: VideoStatus.Editing,
          });
        }

        // Open the standalone editor WITHOUT injecting DatoCMS context, so
        // internal users authenticate as external Clerk users. The SPA's
        // loadDatoContext() reads window.opener.ctx; leaving it unset forces
        // the Clerk sign-in path.
        window.open(
          `${window.location.href.replace(/\/$/, '')}/${
            Studio.creator
          }?storyId=${ctx.item?.id}&env=${ctx.environment}`,
        );

        const newest: Record<any, any> = await dClient.items.find(ctx.item?.id);

        // todo update before creating new window (to not conflict with StoryRepository)
        if (newest.final_video_status === VideoStatus.Editing) {
          if (newest.final_video?.upload_id) {
            await dClient.items.update(ctx.item?.id, {
              final_video_status: VideoStatus.Rendered,
            });
          } else {
            await dClient.items.update(ctx.item?.id, {
              final_video_status: VideoStatus.None,
            });
          }
        }
      }
    } catch (e) {
      // could check e[0].attribues.code === "ITEM_LOCKED" but that isn't exact syntax in typescript
      ctx.alert('Save current story before editing the final video');
    }
  };

  return (
    <Canvas ctx={ctx}>
      <Button type="button" onClick={handleOpenModal}>
        Open Editor
      </Button>
    </Canvas>
  );
}
